import * as R from "ramda";

export const adaptThingTypeByThingName = R.pipe(
  R.pathOr([], ["hits", "hits"]),
  R.reduce(
    (acc, hit) => R.assoc(hit._source.thingName, hit._source.thingType, acc),
    {}
  )
);
